import type { StateCreator } from 'zustand';
import type { MonitoringSlices } from '.';

export interface AudioDrawerSlice {
  showAudioDrawer: boolean;
  openAudioDrawer: () => void;
  closeAudioDrawer: () => void;
}

type StateCreatorAudioDrawer = StateCreator<MonitoringSlices, [['zustand/devtools', never]], [], AudioDrawerSlice>;

const createAudioDrawerSlice: StateCreatorAudioDrawer = (set) => ({
  showAudioDrawer: false,
  openAudioDrawer: () => set({ showAudioDrawer: true }),
  closeAudioDrawer: () => set({ showAudioDrawer: false }),
});

export default createAudioDrawerSlice;
